import {
  property_operations_dashboard_id,
  property_security_dashboard_id,
  property_analytics_dashboard_id,
  property_utilities_dashboard_id,
  property_savings_insights_dashboard_id
} from '@/config/dashboardIds';

export const property_names = [
  "Highveld Crossing",
  "Stonebridge Quarter",
  "Willow Park Estate",
  "Brookfield Junction",
  "Silverleaf Towers",
  "Eastgate Ridge",
  "Northpoint District",
  "Riverbend Offices",
  "Meadowview Heights",
  "Portfolio Property"
];

const portfolio_property_name = "Portfolio Property";

const service_provider_list = [
  { name: "City Power", category: "Electricity", phone: "086 000 7788", icon: "bi bi-lightning-charge-fill" },
  { name: "Johannesburg Water", category: "Water & Sanitation", phone: "011 688 2500", icon: "bi bi-droplet-fill" },
  { name: "Fidelity Services", category: "Security Response", phone: "086 013 4354", icon: "bi bi-shield-lock-fill" },
  { name: "Vuma", category: "Connectivity", phone: "087 820 9000", icon: "bi bi-wifi" },
  { name: "Facilities Desk", category: "Maintenance", phone: "010 500 3000", icon: "bi bi-tools" }
];

const property_dashboard_fallbacks = [
  property_operations_dashboard_id,
  property_security_dashboard_id,
  property_analytics_dashboard_id,
  property_utilities_dashboard_id,
  property_savings_insights_dashboard_id
].filter((dashboard_id) => {
  return dashboard_id && !String(dashboard_id).startsWith("REPLACE_");
});

const property_profiles = [
  {
    name: "Highveld Crossing",
    is_live: true,
    description: "Mixed-use property",
    size: "2,850 sqm",
    occupancy: "99%",
    trend: "+4.2%",
    efficiency: "Energy Efficiency 94%",
    coordinates: { lat: -26.1076, lng: 28.0567 },
    manager: "Naledi Mokoena",
    phone: "011 555 0101",
    email: "highveld.crossing@example.com",
    crimeIndex: "Low"
  },
  {
    name: "Stonebridge Quarter",
    description: "Commercial precinct",
    size: "1,120 sqm",
    occupancy: "96%",
    trend: "+3.1%",
    efficiency: "Operational Uptime 96%",
    coordinates: { lat: -26.1082, lng: 28.0579 },
    manager: "Sibusiso Khumalo",
    phone: "011 555 0102",
    email: "stonebridge.quarter@example.com",
    crimeIndex: "Medium"
  },
  {
    name: "Willow Park Estate",
    description: "Residential estate",
    size: "3,430 sqm",
    occupancy: "100%",
    trend: "+5.8%",
    efficiency: "Resident Satisfaction 91%",
    coordinates: { lat: -26.1091, lng: 28.0556 },
    manager: "Ayesha Patel",
    phone: "011 555 0103",
    email: "willow.park@example.com",
    crimeIndex: "Low"
  },
  {
    name: "Brookfield Junction",
    description: "Business park",
    size: "380 sqm",
    occupancy: "93%",
    trend: "+2.4%",
    efficiency: "Facilities SLA 87%",
    coordinates: { lat: -26.1069, lng: 28.0584 },
    manager: "Lerato Dlamini",
    phone: "011 555 0104",
    email: "brookfield.junction@example.com",
    crimeIndex: "Low"
  },
  {
    name: "Silverleaf Towers",
    description: "Office tower",
    size: "1,540 sqm",
    occupancy: "95%",
    trend: "+2.9%",
    efficiency: "Energy Efficiency 89%",
    coordinates: { lat: -26.1102, lng: 28.0591 },
    manager: "Brandon Jacobs",
    phone: "011 555 0105",
    email: "silverleaf.towers@example.com",
    crimeIndex: "Medium"
  },
  {
    name: "Eastgate Ridge",
    description: "Mixed-use campus",
    size: "420 sqm",
    occupancy: "98%",
    trend: "+6.1%",
    efficiency: "Utilities Stability 91%",
    coordinates: { lat: -26.1073, lng: 28.0601 },
    manager: "Thando Maseko",
    phone: "011 555 0106",
    email: "eastgate.ridge@example.com",
    crimeIndex: "Low"
  },
  {
    name: "Northpoint District",
    description: "Urban precinct",
    size: "1,960 sqm",
    occupancy: "97%",
    trend: "+3.7%",
    efficiency: "Maintenance Health 92%",
    coordinates: { lat: -26.1111, lng: 28.0571 },
    manager: "Michelle Naidoo",
    phone: "011 555 0107",
    email: "northpoint.district@example.com",
    crimeIndex: "Low"
  },
  {
    name: "Riverbend Offices",
    description: "Office complex",
    size: "1,260 sqm",
    occupancy: "94%",
    trend: "+1.8%",
    efficiency: "Space Utilisation 89%",
    coordinates: { lat: -26.1086, lng: 28.0612 },
    manager: "Kgomotso Molefe",
    phone: "011 555 0108",
    email: "riverbend.offices@example.com",
    crimeIndex: "Medium"
  },
  {
    name: "Meadowview Heights",
    description: "Residential towers",
    size: "3,760 sqm",
    occupancy: "100%",
    trend: "+5.4%",
    efficiency: "Energy Efficiency 90%",
    coordinates: { lat: -26.1124, lng: 28.0586 },
    manager: "Michael van Wyk",
    phone: "011 555 0109",
    email: "meadowview.heights@example.com",
    crimeIndex: "Low"
  }
];

function get_property_dashboard_id(index) {
  if (!property_dashboard_fallbacks.length) {
    return property_operations_dashboard_id;
  }

  return property_dashboard_fallbacks[index % property_dashboard_fallbacks.length];
}

function get_crime_stats(profile, index) {
  return ({
    precinct: `${profile.name} Property Precinct`,
    stationContact: `011 555 02${String(index + 1).padStart(2, "0")}`,
    crimeIndex: profile.crimeIndex,
    periodIncrease: `${index % 2 === 0 ? "4% decrease" : "3% increase"} from prior quarter`,
    incidentSummary: [
      { category: "Property Crime", count: 3 + index, trend: index % 2 === 0 ? "-6%" : "+4%" },
      { category: "Theft from Vehicle", count: 1 + (index % 4), trend: "-2%" },
      { category: "Assault", count: index % 3, trend: "0%" },
      { category: "Burglary", count: 1 + (index % 2), trend: "-8%" }
    ],
    lastUpdated: "2026-06-01",
    communityForumLink: "https://example.com/community-safety"
  });
}

function get_team_contacts(profile) {
  return [
    {
      full_name: profile.manager,
      role: "Property Manager",
      status: "on-site",
      hours: "Mon-Fri 8am-5pm",
      phone: profile.phone,
      email: profile.email,
      address: `${profile.name} management office`,
      website: "N/A"
    },
    {
      full_name: "Security Control Room",
      role: "Security Manager",
      status: "on-site",
      hours: "24/7",
      phone: "011 555 0199",
      email: "security@example.com",
      address: `${profile.name} security office`,
      website: "N/A"
    },
    {
      full_name: "Facilities Desk",
      role: "Facilities Manager",
      status: "break",
      hours: "Mon-Sat 7am-7pm",
      phone: "011 555 0188",
      email: "facilities@example.com",
      address: `${profile.name} facilities office`,
      website: "N/A"
    }
  ];
}

function get_recent_documents(profile) {
  return [
    { title: `${profile.name} Monthly Operations Report`, updated: "2 hours ago", size: "2.4 MB", icon: "bi bi-file-earmark-pdf-fill" },
    { title: `${profile.name} Utility Consumption Snapshot`, updated: "yesterday", size: "1.8 MB", icon: "bi bi-file-earmark-excel-fill" },
    { title: `${profile.name} Incident Register`, updated: "3 days ago", size: "856 KB", icon: "bi bi-file-earmark-word-fill" },
    { title: `${profile.name} Maintenance Schedule`, updated: "1 week ago", size: "3.2 MB", icon: "bi bi-file-earmark-pdf-fill" }
  ];
}

function get_shift_schedule() {
  return [
    { label: "Opening Shift", time: "07:00 - 15:00", personnel: 8 },
    { label: "Trading Shift", time: "09:00 - 17:00", personnel: 14 },
    { label: "Closing Shift", time: "13:00 - 21:00", personnel: 10 },
    { label: "Security Patrol", time: "18:00 - 06:00", personnel: 4 }
  ];
}

function get_quick_actions(profile) {
  return [
    { label: "Log maintenance issue", icon: "bi bi-tools", variant: "primary" },
    { label: `Contact ${profile.manager}`, icon: "bi bi-telephone-fill", variant: "secondary" },
    { label: "Download latest report", icon: "bi bi-download", variant: "secondary" }
  ];
}

function get_tile_cards(profile) {
  return [
    {
      id: `${profile.name}-management-contacts`,
      title: "On-Site Team Members",
      type: "details",
      contacts: get_team_contacts(profile)
    },
    {
      id: `${profile.name}-emergency-contacts-map`,
      title: "Emergency Contacts & Location",
      type: "emergency-map",
      locationName: profile.name,
      coordinates: profile.coordinates
    },
    {
      id: `${profile.name}-service-providers`,
      title: "Service Providers",
      type: "service-providers",
      providers: service_provider_list
    }
  ];
}

function get_property_tile(profile, index) {
  return ({
    id: `${profile.name}${profile.is_live ? " (Live)" : ""}`,
    title: profile.name,
    is_live: Boolean(profile.is_live),
    stats: profile.efficiency,
    description: profile.description,
    trend: profile.trend,
    dashboardId: get_property_dashboard_id(index),
    coordinates: profile.coordinates,
    propertyOverview: {
      title: profile.name,
      size: profile.size,
      occupancy: profile.occupancy,
      description: profile.description,
      total_centres: property_profiles.length
    },
    crimeStats: get_crime_stats(profile, index),
    teamContacts: get_team_contacts(profile),
    recentDocuments: get_recent_documents(profile),
    shiftSchedule: get_shift_schedule(profile),
    quickActions: get_quick_actions(profile),
    tileCards: get_tile_cards(profile)
  });
}

export default function getTilesConfiguration() {
  return property_profiles
    .filter((profile) => profile.name !== portfolio_property_name)
    .map((profile, index) => get_property_tile(profile, index));
}
